import initModalQuiz from "../modal-quiz";
import pasteModalInDom from "./pasteModalInDom";
import initAddressSearch from "../dadata-functions/initAddressSearch";
import find_city from "./findCity";
import initAuthorizationModals from "./initAuthorizationModals";

const CLIENT_SIDE_RENDERING_MODALS = new Set([
    "modal-authorization",
    "modal-forget-password",
    "modal-getCity",
    // Модалки нового дизайна
    "modal-address",
    "address-page-modal-address",
    "modal-quiz",
]);
function initClientSideRenderingModals() {
    const modalSelectors = Array.from(CLIENT_SIDE_RENDERING_MODALS)
        .map((id) => `[data-custom-open="${id}"]`)
        .join(", ");
    document.querySelectorAll(modalSelectors).forEach((el) => {
        if (el.dataset.isRender === "1") return;
        el.dataset.isRender = "1";

        el.addEventListener(
            "click",
            async (evt) => {
                const modalId = evt.currentTarget.getAttribute("data-custom-open");
                if (!modalId || !CLIENT_SIDE_RENDERING_MODALS.has(modalId)) return;

                evt.preventDefault();
                evt.stopImmediatePropagation();

                // догружаем модалку при отсутствии в DOM
                if (!document.getElementById(modalId)) {
                    const ok = await pasteModalInDom(modalId);
                    if (!ok) return;
                    initClientSideRenderingModals();
                }

                if (modalId === "modal-authorization") {
                    await initAuthorizationModals();
                }

                if (modalId === "modal-forget-password") {
                    MicroModal.close('modal-authorization');
                }

                if (modalId === "modal-getCity") {
                    let modalGetCity = document.getElementById('modal-getCity');
                    if (modalGetCity.getAttribute('data-full-rendering') === '0') {
                        modalGetCity.remove();
                        const ok = await pasteModalInDom(modalId);
                        if (!ok) return;
                    }
                    find_city();
                }

                if (modalId === "modal-address") {
                    const search = document.getElementById("modal-address");
                    if (!search) return;
                    const input = search.querySelector(".street-input");
                    if (input) input.focus();
                    initAddressSearch();
                }

                if (modalId === "modal-quiz") {
                    initModalQuiz();
                }

                MicroModal.show(modalId);

            },
            true
        );
    });
}

export default initClientSideRenderingModals;
